module.exports = __webpack_public_path__ + "img/myLocation_blue.86ea2201.svg";